module.exports = " <div class=Rightcolumn id=Rightcolumn> <slot></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/columns/Rightcolumn.vue
// module id = 484
// module chunks = 1